/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-11-11 09:49:00
 * @LastEditors: Please set LastEditors
 * @Description: 
 * @FilePath: \cloud_frontend\src\api\particulars.js
 * @
 */
import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";

//获取设备详细信息
export function showDeviceDetail(deviceId) {
    const data = {
        deviceId: deviceId,
        user_id: getuser_id()
    }
    return http({
        url: '/api/device/showDeviceDetail',
        method: 'post',
        data
    })
}
//添加远程服务社区
export function addDeviceN2n(id) {
    const data = {
        id: id
    }
    return http({
        url: '/api/device/addDeviceN2n',
        method: 'post',
        data
    })
}
//删除远程服务社区
export function delDeviceN2n(id) {
    const data = {
        id: id
    }
    return http({
        url: '/api/device/delDeviceN2n',
        method: 'post',
        data
    })
}
//设备设备经纬度
export function updateGps(id, long, lan) {
    const data = {
        id: id,
        longitude: long,
        latitude: lan
    }
    return http({
        url: '/api/device/updateGps',
        method: 'post',
        data
    })
}
//获取进程状态
export function getProgressStatus(did, SN, mess) {
    const data = {
        SN,
        did,
        mess
    }
    return http({
        url: '/api/configListManager/getProgressStatus',
        method: 'post',
        data
    })
}
//进程控制
export function progressControl(mess, did, SN) {
    // console.log(mess, did, SN)
    const data = {
        did: did,
        mess: mess,
        SN: SN
    }
    return http({
        url: '/api/configListManager/progressControl',
        method: 'post',
        data
    })
}

//修改设备名称与设备位置
export function updateDevice(id, deviceName, deviceAddress) {
    const data = {
        id: id,
        deviceName: deviceName,
        deviceAddress: deviceAddress
    }
    return http({
        url: '/api/device/updateDevice',
        method: 'post',
        data
    })
}

// 修改设备名称
export function updateDeviceName(id, deviceName) {
    const data = {
        id,
        deviceName,
    }
    return http({
        url: '/api/device/updateDeviceName',
        method: 'post',
        data
    })
}

// 修改设备位置
export function updateDeviceAddress(id, deviceAddress) {
    const data = {
        id,
        deviceAddress,
    }
    return http({
        url: '/api/device/updateDeviceAddress',
        method: 'post',
        data
    })
}
// 设备详情-下挂设备
export function hangingDevice(data) {
    return http({
        url: '/api/device/printInfo',
        method: 'post',
        data: {
            did: data
        }
    })
}

// 设备详情-wifi
export function wifiInfo(did, sn) {
    return http({
        url: '/api/device/networkInfo',
        method: 'post',
        data: {
            did,
            sn,
            mess: ['wwan']
        }
    })
}

// 在线离线时长清0
export function clearLineTime(did) {
    return http({
        url: '/api/zero/linetime',
        method: 'post',
        data: {
            did,
        }
    })
}
// 流量清0
export function clearTraffic(did) {
    return http({
        url: '/api/zero/traffic',
        method: 'post',
        data: {
            did,
        }
    })
}
/**
 * 获取webssh地址
 */
export function getWebsshUrl(data) {
    return http({
        url: '/api/device/webssh/getIP',
        method: 'post',
        data,
    })
}
/**
 * 移除ip
 */
export function removeDeviceIp(data) {
    return http({
        url: `/api/device/webssh/removeIP`,
        method: 'post',
        data
    })
}

/**
 * 移除所有ip
 */
export function removeAllDeviceIp() {
    return http({
        url: `/api/device/webssh/removeUnuseIP`,
        method: 'get'
    });
}

/**
 * ping IP
 */
export function pingIp(data) {
    return http({
        url: `/api/device/webssh/pingIP`,
        method: 'post',
        data
    })
}

// 心跳
export function heartBeat(data) {
    return http({
        url: `/api/device/webssh/ipConnectHeart`,
        method: 'post',
        data
    })
}

// 失败后调用，记录日志
export function logError(data) {
    return http({
        url: `/api/device/webssh/log`,
        method: 'post',
        data
    })
}